<template>
	<b-row v-if="isCaster">
		<b-col>
			<h4 class="mt-3">Spells</h4>
			<b-list-group flush>

				<b-list-group-item class="p-0" v-for="(known, spellLevel) in known" :key="'spellLevel-'+spellLevel">
					<div class="d-flex justify-content-between">
						<span class="lead">{{spellLevel | ordinal}}</span>

						<span>
							<div class="mr-0 form-check form-check-inline" v-for="(n,i) in perDay[ spellLevel ]" :key="'spellsPerDay-'+spellLevel+'-'+i">
								&#9744;
							</div>
						</span>

						<small class="text-muted">DC {{saveDC[ spellLevel ]}}</small>
					</div>

					<ul class="list-inline mb-0">
						<li class="list-inline-item mr-2" v-for="(spell, index) in list[ spellLevel ]" :key="'spellsList-'+spellLevel+'-'+index">
							{{spell.Name}}
						</li>
					</ul>
				</b-list-group-item>

			</b-list-group>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters('character/spells',[
			'isCaster',
			'known',
			'list',
			'perDay',
			'saveDC',
		]),
	}
}
</script>

<style scoped>

</style>